import { BodyText, ParagraphText } from 'styling/Typography'
import { DropZoneContainer } from './DropZone.styled'
import React, { SetStateAction, useCallback, useRef } from 'react'
import { useDropzone } from 'react-dropzone'

export const DropZone = ({ file, setFile, acceptAll }: { file: File, setFile: React.Dispatch<SetStateAction<File>>, acceptAll?: boolean }) => {
    const inputRef = useRef(null)

    const onDrop = useCallback((acceptedFiles: File[]) => {
        setFile(acceptedFiles[0])
    }, [])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop, accept: acceptAll ? {} : {
            'application/vnd.ms-excel': [],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
        }
    })
    return <DropZoneContainer active={isDragActive} onClick={() => inputRef.current.click()} {...getRootProps()}>
        <input ref={inputRef} {...getInputProps()} />
        {isDragActive ? <BodyText>Drop Here</BodyText> : <ParagraphText>{file ? file.name : 'Drop a file here or click to select'}</ParagraphText>}
    </DropZoneContainer>
}